import { setUser } from "@sentry/react";
import { useTranslation } from "react-i18next";

import { PortalHeading } from "@/components/Portal/components/PortalHeading/PortalHeading";
import { useQueryCallbacks } from "@/hooks/useQueryCallbacks";
import { useGetCustomer } from "@/services/api";

/** The cockpit greeting - "Hi <first name>!" and nothing else, per design. */
export const WelcomeText = () => {
  const { t } = useTranslation("portal");

  const customerQuery = useGetCustomer(undefined, {
    query: {
      // Safe to cache for 5 minutes, as the name will never change.
      staleTime: 5 * 60 * 1000,
    },
  });
  useQueryCallbacks(customerQuery, {
    onSuccess: (data) => {
      setUser({ id: data?.id?.toString() });
    },
  });
  const { data: customer, isPending: customerIsLoading } = customerQuery;

  const customerName = customer?.firstName || "User";

  return (
    <PortalHeading
      isLoading={customerIsLoading}
      variant="cockpit"
      heading={t("cockpit.heading.greeting", { name: customerName })}
    />
  );
};
